export enum OrderEntitledForCredit {
    ALREADY_USED = 'ALREADY_USED',
    FIRST_ORDER_OVER_AMOUNT = 'FIRST_ORDER_OVER_AMOUNT',
    EACH_PRO_SELLER = 'EACH_PRO_SELLER',
    EVERY_ORDER = 'EVERY_ORDER',
}
